import { motion } from 'framer-motion';
import openRateIcon from '../assets/icons/open-rate.png';
import instantIcon from '../assets/icons/instant.png';
import mediaIcon from '../assets/icons/media.png';
import automationIcon from '../assets/icons/automation.png';
import conversationIcon from '../assets/icons/conversation.png';
import secureIcon from '../assets/icons/secure.png';

const benefits = [
  {
    title: "Turn Content into Chatbots",
    description: "Convert your website, PDFs, and docs into smart WhatsApp chatbots instantly.",
    icon: openRateIcon,
  },
  {
    title: "Recover Lost Leads",
    description: "Automatically re-engage leads who dropped off using smart follow-ups on WhatsApp.",
    icon: instantIcon,
  },
  {
    title: "Schedule Smart Messages",
    description: "Send automated messages for birthdays, anniversaries, and key events.",
    icon: mediaIcon,
  },
  {
    title: "No-Code Setup",
    description: "Launch powerful WhatsApp bots in minutes—no coding required.",
    icon: automationIcon,
  },
  {
    title: "Brand-Voice Consistency",
    description: "Your bot mirrors your brand tone, ensuring seamless communication.",
    icon: conversationIcon,
  },
  {
    title: "Realtime Lead Notifications",
    description: "Get notified instantly when a hot lead interacts with your bot.",
    icon: secureIcon,
  },
];


const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.15,
    },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

export default function BenefitsSection() {
  return (
    <motion.section
      className="bg-white py-16"
      initial="hidden"
      whileInView="show"
      viewport={{ once: true }}
      variants={containerVariants}
    >
      <div className="max-w-6xl mx-auto px-4 text-center">
        <motion.h2
          className="text-3xl font-bold mb-4"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          Why WhatsApp Marketing Works Best
        </motion.h2>
        <motion.p
          className="text-gray-600 mb-12"
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
        >
          Reach customers directly with higher open rates and better engagement.
        </motion.p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {benefits.map((item, idx) => (
            <motion.div
              key={idx}
              variants={cardVariants}
              whileHover={{ scale: 1.05 }}
              className="flex flex-col items-center text-center px-6 py-4 border rounded-lg shadow-sm hover:shadow-md transition"
            >
              <img src={item.icon} alt={item.title} className="w-16 h-16 mb-4" />
              <h4 className="text-xl font-semibold mb-2">{item.title}</h4>
              <p className="text-gray-500 text-sm">{item.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.section>
  );
}
